import { render } from "./RestItems.vue?vue&type=template&id=26841f89"
import script from "./RestItems.vue?vue&type=script&lang=js"
export * from "./RestItems.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__